import {useCallback} from 'react';

import {
  AnalyticsProvider,
  ClientProvider,
  ParentMessageBus,
  WidgetAPI,
  WidgetProvider,
} from '@stripe-internal/conversations-ui';

import {FileUploadProvider} from './FileUploadProvider';
import {useApp, useConfig} from '../hooks/appHooks';

export function ConversationsUIProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  const app = useApp();
  const config = useConfig();

  const actionHandler = useCallback<WidgetAPI['requestAction']>(
    (action, opts) => app.requestAction({action, ...opts}),
    [app],
  );

  return (
    <AnalyticsProvider analytics={app.analytics}>
      <ClientProvider value={app.client}>
        <FileUploadProvider>
          <WidgetProvider
            initialVisibility={config.initialVisibility}
            audience={config.audience}
            entryPoint={config.entryPoint}
            parentOrigin={config.parentOrigin}
            actionHandler={actionHandler}
            parentMessageBus={app.parentMessageBus as ParentMessageBus}
          >
            {children}
          </WidgetProvider>
        </FileUploadProvider>
      </ClientProvider>
    </AnalyticsProvider>
  );
}
